import state from './moduleAboutUsState.js'
import mutations from './moduleAboutUsMutations.js'
import actions from './moduleAboutUsActions.js'
import getters from './moduleAboutUsGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

